import React from "react";
import Field from "./Field";
import SelectInput from "../atoms/SelectInput";

// Molecule: Field (select). Options are passed as children so the molecule
// stays data-agnostic (Country, State, ... all reuse it).
const SelectField = ({ label, name, id, value, onChange, required = false, error, children }) => {
    const controlId = id || name;
    return (
        <Field label={label} htmlFor={controlId} required={required} error={error}>
            <SelectInput id={controlId} name={name} value={value} onChange={onChange}>
                {children}
            </SelectInput>
        </Field>
    );
};

export default SelectField;
